import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type CheckoutRequest = components["schemas"]["CheckoutRequest"];
export type CheckoutResponse = components["schemas"]["CheckoutResponse"];

/** POST /v1/billing/checkout — open a Polar checkout session; returns its URL. */
export async function createCheckout(body: CheckoutRequest): Promise<CheckoutResponse> {
  return unwrap(await api.POST("/v1/billing/checkout", { body }));
}
